import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import EditReport from '../components/report/EditReport'
import Login from '../components/login/Login'
import ProduceReport from '../components/report/ProduceReport'
import Logout from '../components/login/Logout'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      props: true
    },
    {
      path: '/edit_report/:orderSn/departmentList/presetList',
      name: 'EditReport',
      component: EditReport,
      props: true
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/produce_report/:orderSn/departmentList/presetList',
      name: 'ProduceReport',
      component: ProduceReport,
      props: true
    },
    {
      path: '/pdfView',
      name: 'pdfView',
      component: () => import('../components/pdfView.vue'),
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js